import {
  createHubFilterStore,
  useGenericActiveProjectHubFilterCount,
  useGenericHasProjectHubFilters,
} from '@/shared/hooks/use-hub-filter-store';

export const useForecastsFilterStore = createHubFilterStore({
  name: 'forecasts-filter-storage',
  partialize: (state) => ({
    projectIds: state.projectIds,
    subprojectIds: state.subprojectIds,
  }),
});

export const useActiveForecastsFilterCount = () =>
  useGenericActiveProjectHubFilterCount(useForecastsFilterStore());
export const useHasForecastsFilters = () =>
  useGenericHasProjectHubFilters(useForecastsFilterStore());
